import React, { Component } from "react";
import Control from "./control";

class Custom extends Component {
    state = {
        data: this.props.data,
        restData: this.props.restData,
        loaded: false,
        colsTemplateCount: 12,
        colsFormCount: 12,
    };

    constructor(props) {
        super(props);
        let manager = this.props.manager.state;
        let templateConfiguration = manager.module.templateConfiguration;
        if (templateConfiguration.events) {
            Object.keys(templateConfiguration.events).map((itm, idx) => {
                this[itm] = templateConfiguration.events[itm].bind(this);
            });
        }
        this.form = React.createRef();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.action) {
            return false;
        }
        return true;
    }

    componentDidMount() {
        let manager = this.props.manager.state;
        let templateConfiguration = manager.module.templateConfiguration;
        const innerTemplates = [
            "custom",
            "header"
        ];

        innerTemplates.map((itm, idx) => {
            let tmp = templateConfiguration[itm + "Template"]
                ? templateConfiguration[itm + "Template"]
                : () => {};
            this[itm + "Template"] = tmp.bind(this);
        });

        let useCard =
            typeof templateConfiguration.useCard !== "undefined"
                ? templateConfiguration.useCard
                : true;

        let colsTemplateCount = templateConfiguration.colsTemplateCount
            ? templateConfiguration.colsTemplateCount
            : this.state.colsTemplateCount;
        let colsFormCount = templateConfiguration.colsFormCount
            ? templateConfiguration.colsFormCount
            : this.state.colsFormCount;

        this.setState({
            loaded: true,
            colsTemplateCount: colsTemplateCount,
            colsFormCount: colsFormCount,
            useCard: useCard,
        });

        if (this.didMount) {
            this.didMount();
        }
    }

    render() {
        if (this.state.loaded) {
            return (
                <React.Fragment>
                    {this.headerTemplate()}
                    {this.customTemplate()}

                </React.Fragment>
            );
        } else {
            return "loading...";
        }
    }
}

export default Custom;

